import { Heading, Stack, Text } from '@chakra-ui/react'
import { QueryDocumentSnapshot } from 'firebase/firestore'
import moment from 'moment'
import { memo, Ref } from 'react'
import AZSelector from '../../../../components/AZSelector'
import UsersTable, { UsersTableRef } from '../../../../components/UsersTable'
import { ReportInfo } from '../../../../types/ReportTypes'
import FirestoreUser from '../../../../types/FirestoreUser'
import { ButtonType } from '../../../../utils/completionQueries'

interface Props {
  data: {
    month: string
    complete: QueryDocumentSnapshot<FirestoreUser>[]
    incomplete: QueryDocumentSnapshot<FirestoreUser>[]
  }
  reportsData: Record<string, ReportInfo>
  completeTableRef: Ref<UsersTableRef>
  incompleteTableRef: Ref<UsersTableRef>
  onLetterClick: (letter: string) => void
  selectedButton: ButtonType
}

const CompletionResults = memo(function CompletionResults({
  data,
  reportsData,
  completeTableRef,
  incompleteTableRef,
  onLetterClick,
  selectedButton,
}: Props) {
  const getDisplayMonth = () => {
    if (selectedButton === 'last3') {
      return `${data.month} -> ${moment(data.month)
        .add(2, 'months')
        .format('YYYY-MM')}`
    }
    if (selectedButton === 'last6') {
      return `${data.month} -> ${moment(data.month)
        .add(5, 'months')
        .format('YYYY-MM')}`
    }
    return data.month
  }

  return (
    <Stack spacing={4}>
      <Heading fontSize='lg'>Results for: {getDisplayMonth()}</Heading>

      <AZSelector
        docs={[...data.complete, ...data.incomplete]}
        field='lastName'
        hasMore={false}
        onLetterClick={onLetterClick}
      />

      <Stack spacing={2}>
        <Heading fontSize='md'>Complete ({data.complete.length}):</Heading>
        <UsersTable
          ref={completeTableRef}
          docs={data.complete}
          lastNameFirst
          reports={reportsData}
        />
        <Text>{data.complete.map((d) => d.get('email')).join(',')}</Text>
      </Stack>

      <Stack spacing={2}>
        <Heading fontSize='md'>Incomplete ({data.incomplete.length}):</Heading>
        <UsersTable
          ref={incompleteTableRef}
          docs={data.incomplete}
          lastNameFirst
          reports={reportsData}
        />
        <Text>{data.incomplete.map((d) => d.get('email')).join(',')}</Text>
      </Stack>
    </Stack>
  )
})

export default CompletionResults
